module.exports = __webpack_public_path__ + "img/icon-download.86f44939.svg";